module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEDSURBVHgBnZKxDYJgEIX50cJOSjvtoMQNdAMC9LqBOoE6gXECcQFwBJ3A2NGpE4idDeB3RhNNFIgvOe887t27O9C0P6HKChzHMXRdnyql7DRNlxsgeb2MCGmRZZmW5/ka8kIaVSICG8I2DMMAL+rNwlF93++htEIpgdCRHP8DJp18EF3XHeOm2EkMgo0fRlG0e+7ZRPX8qldvBzjSsYsfQephfbonvyb6tuOrq6EVoCY/cRzfTNNsoBagZLBTTHpmWVbCs4NMRNwiTj5G/QaKOzSIRBn/mOD9OKXgaHuaDJ7xBWtLXK/A3WK253lX1pBXcpVk6QdA4ZzdDUgDzCm6dCXcAVzjeWhzwbl1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/f4.png
// module id = M4Yl
// module chunks = 1